import { getBackend } from "./baseService";

export async function getStreamingEpisodes() {
    const response = await getBackend().get('/api/streaming');

    return response.data;
}